document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".carousel").forEach((carousel, carouselIndex) => {
        let currentSlide = 0;
        const slides = carousel.querySelectorAll(".carousel-slide");
        const dots = carousel.querySelectorAll(".dot");

        function showSlide(index) {
            slides.forEach((slide, i) => {
                slide.classList.toggle("active", i === index);
                dots[i].classList.toggle("active", i === index);
            });
        }

        function nextSlide() {
            currentSlide = (currentSlide + 1) % slides.length;
            showSlide(currentSlide);
        }

        function prevSlide() {
            currentSlide = (currentSlide - 1 + slides.length) % slides.length;
            showSlide(currentSlide);
        }

        function goToSlide(index) {
            currentSlide = index;
            showSlide(currentSlide);
        }

        // Attach event listeners specific to this carousel
        carousel.querySelector(".left-arrow").addEventListener("click", prevSlide);
        carousel.querySelector(".right-arrow").addEventListener("click", nextSlide);
        dots.forEach((dot, index) => dot.addEventListener("click", () => goToSlide(index)));

        // Initialize first slide
        showSlide(currentSlide);
    });
});